class WidgetRequest {
    url : string = "";
    executionDate : Date = new Date();
    expirationDate : Date = new Date();
    selectedSpecialisation : string = "";
    selectedRegion : string = "";
    appointmentDate : string = "";
    daysToFetch : number = 0;
}

export default WidgetRequest;